// extracted by mini-css-extract-plugin
export var abc = "styles-module--abc--ac645";
export var content = "styles-module--content--f8158";
export var copyright = "styles-module--copyright--77199";
export var desktop = "1340px";
export var footer = "styles-module--footer--e4089";
export var giant = "2200px";
export var input = "styles-module--input--ccef1";
export var inputContainer = "styles-module--inputContainer--c06fb";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var nav = "styles-module--nav--851c1";
export var nav__ul = "styles-module--nav__ul--565be";
export var newsletter = "styles-module--newsletter--65409";
export var newsletter__CTA = "styles-module--newsletter__CTA--e02de";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var submitted = "styles-module--submitted--b9fe0";
export var successMessage = "styles-module--successMessage--7da0e";
export var tablet = "769px";
export var visible = "styles-module--visible--d3a2c";
export var wordmark = "styles-module--wordmark--04cbc";